module.exports = __webpack_public_path__ + "img/wechat.a76f0dc1.png";